<template>
  <footer :class="{ 'landing-page': isLandingPage }">
    ©2010-{{ new Date().getFullYear() }} Alexy Üvegtechnika Orosháza Kft.

    <div v-if="isLandingPage">
      <router-link
        class="statement-link"
        to="/adatvedelmi-nyilatkozat"
      >
        Adatvédelmi nyilatkozat
      </router-link>
      |
      <router-link
        class="statement-link"
        to="/jogi-nyilatkozat"
      >
        Jogi nyilatkozat
      </router-link>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'foot',
    computed: {
      isLandingPage() {
        return this.$route.name === 'LandingPage';
      },
    },
  };

</script>

<style scoped>
  footer {
    position: absolute;
    bottom: 0;
    left: 0;
    margin-left: 340px;
    margin-right: 40px;
    padding: 1rem;
    text-align: center;
    width: calc(100% - 340px);
  }

  @media (max-width: 992px) {
    footer {
      width: 100%;
      margin-left: 0;
    }
  }

  .landing-page {
    width: 100%;
    margin-left: 0;
  }

  .statement-link {
    text-decoration: none;
    font-weight: normal;
  }

</style>



// WEBPACK FOOTER //
// Foot.vue?4be5c078